import { Injectable } from '@angular/core';
import { GalleryDto } from '@picflow/types';
import { planPermissions, productsToSell } from '../consts';
import { getPermissions } from '../lib/get-allowed-feedback-options';
import { StateService } from './state.service';

@Injectable({
  providedIn: 'root',
})
export class PermissionService {
  constructor(private state: StateService) {}

  private getPermissions(gallery: GalleryDto) {
    if (!gallery) {
      if (!this.state.plan) return;
      return this.state.plan.limits.permissions;
    }
    return getPermissions(gallery, this.state.plan);
  }

  private convertPermission(permission: string): { category: string; value: string; inverted: boolean } | boolean {
    if (permission[0] === '!!') permission = permission.substring(2);
    if (permission === '!undefined') return false;
    if (permission === 'undefined') return true;

    let category = permission.split('.')[0];
    let value = permission.split('.')[1];

    // Temporary fix for embed-gallery, can be removed after the next release
    if (value === 'embed-gallery') {
      category = 'tenant';
      value = 'logoUpload';
    }

    return { category: category.split('!').join(''), value, inverted: permission[0] === '!' };
  }

  canDisplayElement(permission: string, gallery?: GalleryDto): boolean {
    const resp = this.convertPermission(permission);
    if (resp === true || resp === false) return resp;

    const permissions = this.getPermissions(gallery);
    if (!permissions) {
      if (permission.startsWith('!')) return true;
      return false;
    }

    if (resp.inverted) {
      return !permissions[resp.category][resp.value];
    }
    return permissions[resp.category][resp.value];
  }

  public getMinPlanForPermission(permission: string): string {
    const resp = this.convertPermission(permission);
    if (resp === true || resp === false) return undefined;

    const plans = Object.keys(planPermissions)
      .filter(planName => {
        return planPermissions[planName].permissions[resp.category][resp.value];
      })
      .map(planName => planName.split('Picflow ')[1].toLowerCase());

    const plan = productsToSell.find(productName => plans.includes(productName));

    return plan;
  }

  public shouldRedirectToPricingPage(tenantId: string): boolean {
    if (!tenantId || tenantId === this.state.activeTenant?.id) {
      return ['admin', 'owner'].includes(this.state.activeTenantRole);
    }
    return false;
  }

  public hasRolePermission(permission: string): boolean {
    if (!this.state.activeTenantPermissions) return false;
    return this.state.activeTenantPermissions.includes(permission);
  }
}
